<template>
    <li class="prize-small">
        <img v-if="image" :src="image | cdn({ width: 70, height: 70 })" alt="Prize" class="prize-small__image" />
        <img
            v-else
            :src="require('../../assets/default-images/prize.svg')"
            alt="Default prize image"
            class="prize-small__image prize-small__image--alt"
        />
        <div class="prize-small__info">
            <p class="prize-small__heading">{{ title }}</p>
            <!--            <p class="prize-small__subheading">{{ price }}</p>-->
        </div>
    </li>
</template>

<script>
import './prize-small.scss';

export default {
    name: 'PrizeSmall',
    props: {
        prizeTitle: {
            type: String,
            default: 'Prize title',
        },
        quantity: {
            type: Number,
            default: 1,
        },
        value: {
            type: Number,
            default: 1,
        },
        image: {
            type: String,
            default: '',
        },
        sponsor: {
            type: Object,
        },
    },
    computed: {
        title() {
            return this.quantity + ' x ' + this.prizeTitle;
        },
        price() {
            return (
                'T.w.v. ' +
                this.cleanPrice(
                    this.value.toLocaleString('en-NL', {
                        style: 'currency',
                        currency: 'EUR',
                    })
                )
            );
        },
    },
    methods: {
        cleanPrice(price) {
            const regex = /\.00$/m;

            return regex.test(price) ? price.replace(regex, '') : price;
        },
    },
};
</script>
